import { render, staticRenderFns } from "./mainType.vue?vue&type=template&id=f3bba1da&scoped=true"
import script from "./mainType.vue?vue&type=script&lang=js"
export * from "./mainType.vue?vue&type=script&lang=js"
import style0 from "./mainType.vue?vue&type=style&index=0&id=f3bba1da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_vue-template-compiler@2.7.16_webpack@5.90.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bba1da",
  null
  
)

export default component.exports